<hr [ngStyle]="style" [attr.color]="config?.color ? config?.color : null"/>